import { render, staticRenderFns } from "./CategoryGrid.vue?vue&type=template&id=7a7d44ce&"
import script from "./CategoryGrid.vue?vue&type=script&lang=js&"
export * from "./CategoryGrid.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports